import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppDispatchContext, AppStateContext } from '../../context/AppContext';
import {
    StyledDefaultModalHeader,
    StyledDefaultModalBody,
    StyledDefaultModalFooter,
    AccentButton,
} from '../../styles/common';
import { paths, helpDeskPaths, helpDeskPath } from '../../constants';

const ForceRecycleWarning = () => {
    const dispatch = useContext(AppDispatchContext);
    const { device } = useContext(AppStateContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location || {};
    const isHelpDesk = pathname && pathname.includes(helpDeskPath);

    const handleCancel = () => {
        dispatch({ type: 'CLEAR_MODAL' });
    };

    const handleProceed = () => {
        dispatch({ type: 'CLEAR_MODAL' });
        dispatch({
            type: 'SET_DEVICE',
            device,
            goBackLink: pathname,
        });
        navigate(isHelpDesk ? helpDeskPaths.recycle : paths.recycle);
    };

    const warningText = device && device.user
        ? t('forceRecycleWarning$assignedUser', { user: device.user })
        : t('forceRecycleWarning$assignedGeneric');

    return (
        <>
            <StyledDefaultModalHeader>
                {t('forceRecycleWarning$title')}
            </StyledDefaultModalHeader>
            <StyledDefaultModalBody>
                <div>{warningText}</div>
                <div>{t('forceRecycleWarning$consequence')}</div>
            </StyledDefaultModalBody>
            <StyledDefaultModalFooter>
                <AccentButton
                    outline
                    color="secondary"
                    size="sm"
                    onClick={handleCancel}
                >
                    {t('forceRecycleWarning$cancel')}
                </AccentButton>
                <AccentButton
                    outline
                    color="primary"
                    size="sm"
                    onClick={handleProceed}
                >
                    {t('forceRecycleWarning$proceed')}
                </AccentButton>
            </StyledDefaultModalFooter>
        </>
    );
};

export default ForceRecycleWarning;
